import type { AuditIndexItem } from "@/types";

export default function AuditIssueCount({ audit }: { audit: AuditIndexItem }) {
  if (audit.issue_count === 0) {
    return <span className="text-xs font-medium text-green-700">No Issues</span>;
  }

  return (
    <span className="text-xs font-medium text-red-700">
      {audit.issue_count} {audit.issue_count === 1 ? "issue" : "Issues"}
    </span>
  );
}
